import { parse, differenceInMinutes, differenceInDays } from 'date-fns';
import STRINGS from '../global/strings';

export const getHebrewDays = (days) => {
    let tmp = days.filter((ch) => ch === 1 || ch === 2 || ch === 3 || ch === 4 || ch === 5 || ch === 6 || ch === 7)
    let str = (tmp.length === 7
        ? 'כל יום'
        : tmp
            .sort()
            .map((day) => (day === 1 ? 'א' : day === 2 ? 'ב' : day === 3 ? 'ג' : day === 4 ? 'ד' : day === 5 ? 'ה' : day === 6 ? 'ו' : day === 7 ? 'ש' : ''))
            .join()
    )
    return str;
}


export const getTranslatedDays = (languageMapping, days) => {

    if (languageMapping && days) {

        let filteredDays = days.filter(
            (day) =>
                day === 1 ||
                day === 2 ||
                day === 3 ||
                day === 4 ||
                day === 5 ||
                day === 6 ||
                day === 7
        );

        let translatedDays = filteredDays.map((day) => languageMapping[day]);
        let str = filteredDays.length === 7 ? 'Every day' : translatedDays.sort().join(', ');
        return str;
    }
    else {
        return '';
    }
}

export const isToday = (days) => {
    const d = new Date();
    let today = d.getDay()
    if (days.length === 1 && days[0] === today) return true
    else return false
}


function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}


export const convertMsToHM = (milliseconds) => {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
}


export const convertHMS = (value) => {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - (hours * 3600)) / 60);
    let seconds = sec - (hours * 3600) - (minutes * 60);
    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
}



export const isTimePassed = (timeStr) => {
    timeStr = timeStr.replace(/^(?:00:)?0?/, '');
    const [hours, mins] = timeStr.split(':')
    var time = new Date();
    time.setHours(hours, mins)
    var now = new Date();
    var nowTime = now.getHours() * 60 + now.getMinutes();
    var dateTime = time.getHours() * 60 + time.getMinutes();
    if (nowTime > dateTime) {
        return true
    }
    return false
}


export const strToDate = (str) => {
    const [dateValues, timeValues] = str.split(' ')
    const [day, month, year] = dateValues.split('/');
    const [hours, minutes, seconds] = timeValues.split(':');
    const date = new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
    return { date, dateValues, timeValues, month, day, year, hours, minutes, seconds }
}


export const strToTime = (str) => {
    const [hours, minutes, seconds] = str.split(':');
    return [hours, minutes, seconds]
}


export const durationInMinutes = (startTime, endTime) => {
    return differenceInMinutes(
        parse(endTime, 'dd/MM/yyyy HH:mm:ss', new Date()),
        parse(startTime, 'dd/MM/yyyy HH:mm:ss', new Date())
    );
}


export const campareDates = (date1, date2) => {
    return differenceInMinutes(
        parse(date2, 'dd/MM/yyyy HH:mm:ss', new Date()),
        parse(date1, 'dd/MM/yyyy HH:mm:ss', new Date())
    );
}


export const campareDatesOnly = (date1, date2) => {
    return differenceInDays(
        parse(date2, 'dd/MM/yyyy', new Date()),
        parse(date1, 'dd/MM/yyyy', new Date())
    );
}


export const campareTimes = (date1, date2) => {
    return differenceInMinutes(
        parse(date2, 'HH:mm:ss', new Date()),
        parse(date1, 'HH:mm:ss', new Date())
    );
}


export const campareTime = (time1, time2) => {
    const [hours1, minutes1, seconds1] = strToTime(time1)
    const [hours2, minutes2, seconds2] = strToTime(time2)

    return hours2 * 10000 + minutes2 * 70 + seconds2 - (hours1 * 10000 + minutes1 * 70 + seconds1)
}

export const timeToHebrew = (duration) => {
    if (duration < 0) duration = -duration
    let hours = Math.floor(duration / 60);
    let minutes = duration % 60
    switch (hours) {
        case 0:
            return `${minutes} ${STRINGS.MINUTES}`;
        case 1:
            return `${STRINGS.HOUR} ו- ${minutes} ${STRINGS.MINUTES}`;
        default:
            return `${hours} ${STRINGS.HOURS} ו- ${minutes} ${STRINGS.MINUTES}`;
    }
}